let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hVLrV")).then(() => parcelRequire('6nw6j'));